import React, { useState, useEffect } from "react";
import "../index.scss";
import { Col, Row } from "react-bootstrap";
import Button from "../../../../../components/common/button";
import PolicyEraImg from "../../../../../assets/images/PolicyEra.jpeg";
import Timer from "../../../../../assets/images/timer.gif";
import WatchTimer from "../../../../../assets/images/watchTimer.gif";
import {
  formatAmount,
  getNameAbbrevation,
  getParamsFromURL,
  setParamsInURL,
} from "../../../../../utils/helper";
import NoDataFound from "../../../../../components/NoDataFound";
import { useDispatch, useSelector } from "react-redux";
import UpgradeCard from "./upgradeCard";
import { useLocation, useNavigate } from "react-router-dom";
import { renewal, orderSummary } from "../../../../../utils/router/constant";
import Whyupgrade from "./whyUpgrade";
import { getRenewalDetail } from "../../../../../service/renewal/renewalService";
import { updateForm } from "../../../../../service/proposal/proposalService";
import Loader from "../../../../../components/common/loader";
import { setRenewalDetailData } from "../../../../../store/slices/renewal/renewalSlice";

const RenewalDetails = () => {
  const dispatch = useDispatch();
  const renewalDetailData = useSelector(
    (state) => state.renewal.renewalDetailData
  );
  const [orderId, setOrderId] = useState(null);
  const nav = useNavigate();
  const location = useLocation();
  const loading = useSelector((state) => state.common.loading);

  const redirectUrl = () => {
    nav(renewal);
  };

  useEffect(() => {
    return () => {
      dispatch(setRenewalDetailData({}));
    };
  }, [dispatch]);

  useEffect(() => {
    const fetchCode = async () => {
      dispatch(setRenewalDetailData({}));
      await getParamsFromURL(location).then((params) => {
        if (params && params["orderId"]) {
          setOrderId(params["orderId"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location, dispatch]);

  useEffect(() => {
    if (orderId) {
      getRenewalDetail(orderId);
    }
  }, [orderId]);

  const handleUpgrade = async (currentJSON) => {
    if (!renewalDetailData?.renewal_order?.entityid) {
      return;
    }
    const entity = {
      status: renewalDetailData.renewal_order.status,
      current_variant_json: currentJSON,
    };
    const paramObject = {
      entityid: renewalDetailData.product_id,
      orderId: renewalDetailData.renewal_order.entityid,
    };
    const params = await setParamsInURL(location, paramObject);
    const response = await updateForm(
      entity,
      renewalDetailData.renewal_order.entityid,
      "ODR",
      true
    );
    if (response) {
      nav(`${orderSummary}?${params}`);
    }
  };

  const isDataReady =
    !loading &&
    renewalDetailData &&
    renewalDetailData.renewal_order &&
    renewalDetailData.renewal_order.entityid;

  return (
    <div>
      {!isDataReady ? (
        <Loader />
      ) : (
        <div className="insurance--card renewal-detail-view">
          <div className="insurance--card--header">
            {renewalDetailData?.renewal_order?.product_details.map(
              (variant, index) => (
                <img
                  key={index}
                  src={variant.media_url ? variant.media_url : PolicyEraImg}
                  className="product-variant-image"
                  alt="Product Variant"
                />
              )
            )}
          </div>
          <div className="renewal--card--content">
            {/* <Row> */}
            <div className="order-details">
              <div className="header--avatar">
                {getNameAbbrevation(renewalDetailData?.billing_name)}
              </div>
              <div className="product-detail">
                <div className="user-name">
                  {renewalDetailData?.billing_name}
                </div>
                <Row className="product--details--wrapper">
                  <Col md={5}>
                    <div className="card--content--title">Product Name</div>
                    <div className="card--content--subtitle">
                      {renewalDetailData?.name}
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="card--content--title">Order ID</div>
                    <div className="card--content--subtitle">
                      #{renewalDetailData?.renewal_order?.code}
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="card--content--title">Cover</div>
                    <div className="card--content--subtitle">
                      {formatAmount(
                        renewalDetailData?.renewal_order?.cover_amount
                      )}
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="card--content--title">Premium</div>
                    <div className="card--content--subtitle">
                      {formatAmount(
                        renewalDetailData?.renewal_order?.gross_amount
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="gif-wrapper">
                {renewalDetailData?.renewal_remaining_days ? (
                  <>
                    <div className="days-left">
                      {renewalDetailData?.renewal_remaining_days} Days Left
                    </div>

                    <div className="timer-container">
                      <img src={Timer} className="img-fluid" alt="Countdown" />
                    </div>
                  </>
                ) : renewalDetailData?.renewal_grace_remaining_days ? (
                  <>
                    <div className="days-left-grace">
                      Lapse In {renewalDetailData?.renewal_grace_remaining_days}{" "}
                      Days
                    </div>

                    <div className="timer-container">
                      <img
                        src={WatchTimer}
                        className="img-fluid"
                        alt="Countdown"
                      />
                    </div>
                  </>
                ) : null}
              </div>
            </div>
            <div className="button---group">
              <Button
                type="button"
                variant="grey-outlined"
                label="VIEW DETAILS"
                className="view-details-btn"
                onClick={redirectUrl}
              />
            </div>
            <div className="upgrade-card">
              <Row>
                {Array.isArray(renewalDetailData?.upscale_products) &&
                renewalDetailData?.upscale_products.length > 0 ? (
                  renewalDetailData?.upscale_products?.map((data, index) => {
                    return (
                      <Col xs={12} lg={6} key={index}>
                        <UpgradeCard
                          orderDetail={data}
                          handleUpgrade={handleUpgrade}
                        />
                      </Col>
                    );
                  })
                ) : (
                  <NoDataFound />
                )}
              </Row>
              <Whyupgrade />
            </div>
            <div className="horizontal--line--wrapper">
              <div className="horizontal--line"></div>
            </div>
            <div className="renewal--card--footer">
              <div
                className="view--link"
                onClick={() =>
                  handleUpgrade(
                    renewalDetailData?.renewal_order?.variant_json
                  )
                }
              >
                Continue with existing policy
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RenewalDetails;
